"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMSUploadExcel = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const popup_1 = require("../../../base/popup");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const classes_1 = require("../../../base/classes");
const sms_1 = require("../../../../server/sms");
const react_query_1 = require("react-query");
const option_1 = require("../../../../common/option");
const SMSUploadExcelStyled = styled_components_1.default.div `
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 12px;

	.pink {
		color: var(--color-pink, #f46790);
		text-align: center;
		font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
		font-weight: var(--b1-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.text {
		color: var(--color-black, #101010);
		text-align: center;
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);

		font-weight: var(--b3-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.body-wrap {
		width: 100%;
		white-space: break-spaces;
		text-align: center;
	}

	.excel-download {
		border-radius: 4px;
		padding: 4px 6px;
	}

	${props => (props.$isMobile ? mobileStyled : props.$isTablet ? tabletStyled : desktopStyled)}
`;
const mobileStyled = (0, styled_components_1.css) `
	.pink {
		font-size: var(--b1-font-size, 18px);
		line-height: 150%;
		letter-spacing: var(--b1-letter-spacing, -0.02em);
	}
	.text {
		font-size: var(--b3-font-size, 14px);
		line-height: 150%;
		letter-spacing: var(--b3-letter-spacing, -0.02em);
	}

	.sms-upload-excel {
		display: flex;
		flex: 1;
		.button {
			p {
				text-align: center;
				font-size: var(--b5-font-size, 14px);
				line-height: var(--b5-line-height, 20px);
				letter-spacing: var(--b5-letter-spacing, -0.02em);
			}
		}
	}

	.sample-file-download {
		padding: 10px 0 !important;
	}
`;
const tabletStyled = (0, styled_components_1.css) `
	.pink {
		font-size: var(--b1-font-size, 22px);
		line-height: var(--b1-line-height, 42px);
		letter-spacing: var(--b1-letter-spacing, -0.02em);
	}
	.text {
		font-size: var(--b3-font-size, 16px);
		line-height: var(--b3-line-height, 32px);
		letter-spacing: var(--b3-letter-spacing, -0.02em);
	}
`;
const desktopStyled = (0, styled_components_1.css) `
	.pink {
		font-size: var(--b1-font-size, 20px);
		line-height: var(--b1-line-height, 42px);
		letter-spacing: var(--b1-letter-spacing, -0.02em);
	}

	.text {
		font-size: var(--b3-font-size, 16px);
		line-height: var(--b3-line-height, 32px);
		letter-spacing: var(--b3-letter-spacing, -0.02em);
	}
`;
exports.SMSUploadExcel = react_1.default.memo(({ receiverMemberList, setExcelUploadData, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const classesId = (0, classes_1.getClassesId)();
    const [file, setFile] = react_1.default.useState([]); //파일
    const [fileName, setFileName] = react_1.default.useState(''); //파일명
    const [receivers, setReceivers] = react_1.default.useState([]); //업로드 할 수신자 목록
    const [isUpload, setIsUpload] = react_1.default.useState(false); //업로드 성공 여부
    const excelUploadMutation = (0, react_query_1.useMutation)(sms_1.postExcelUpload);
    (0, react_1.useEffect)(() => {
        if (file.length > 0) {
            setFileName(file[0].name);
        }
        else {
            setFileName('');
            setExcelUploadData([]);
            setIsUpload(false);
        }
    }, [file]);
    const handleUpload = async () => {
        try {
            const response = await excelUploadMutation.mutateAsync(file[0]);
            if (response) {
                setIsUpload(true);
                if (response.result.receivers.length === 0) {
                    setIsUpload(false);
                }
                else {
                    setReceivers(response.result.receivers);
                }
                if (response.result.skip > 0) {
                    alert(`${t('sendSMS.excelSkip', { skip: response.result.skip })}`);
                }
                else {
                    alert(t('sendSMS.fileUploadOk'));
                }
            }
            else {
                setIsUpload(false);
            }
        }
        catch (error) {
            alert(t('sendSMS.fileUploadFail'));
            console.error('Error Excel Upload ', error);
            setIsUpload(false);
        }
    };
    (0, react_1.useEffect)(() => {
        if (fileName !== '') {
            handleUpload();
        }
    }, [fileName]);
    (0, react_1.useEffect)(() => {
        if (isUpload) {
            handlerAdd();
        }
    }, [isUpload]);
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    const handlerAdd = () => {
        if (receivers.length > 0) {
            const newReceiverList = receivers.filter(item => !receiverMemberList.some(receiver => receiver.data[1] === item[1]));
            const duplicateCount = receivers.length - newReceiverList.length;
            if (duplicateCount > 0) {
                alert(`${t('sendSMS.fileAddCount', { count: newReceiverList.length })}`);
            }
            const receiverList = newReceiverList
                .filter(item => item[1].length <= 11)
                .map((item) => ({
                id: item[1],
                data: [
                    item[0],
                    item[1],
                    item[2] ? item[2] : '-',
                    item[3] ? item[3] : '-',
                    item[4] ? item[4] : '-',
                    item[5] ? item[5] : '-',
                ]
            }));
            setExcelUploadData(prevData => {
                const list = [
                    ...(prevData ? [...prevData] : []),
                    ...receiverList.filter(data => !prevData.some(item => item.id === data.id)),
                ];
                return list;
            });
            closePopup();
        }
        else {
            alert(t('sendSMS.checkFile'));
        }
    };
    const handlerDownload = async () => {
        const url = `/api/mimac/v1/messages/download-excel-form?&class_id=${classesId}&format=true`;
        window.location.href = url;
    };
    return (react_1.default.createElement(SMSUploadExcelStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "upload-popup" },
        react_1.default.createElement(option_1.FileAttach, { id: "sms-upload-excel", isRegist: true, isNotice: true, fileList: file, setAttachFileList: setFile, isSMSRegist: true, handlerDownload: handlerDownload })));
});
